export default __webpack_public_path__ + "static/media/404.8f9565d1.png";